module.exports = __webpack_public_path__ + "static/media/flag-cameroon-800.9df60166.png";